module.exports = (props) ->
  <a
    className="logo"
    href="http://gradepro.org"
    target="_blank"
    rel="noopener noreferrer">
      <img src={props.logoSrc ? 'images/logo_new.png'} />
  </a>
